import {Component, OnInit} from '@angular/core';
import {BmBankTransactionFamilyBaseComponent} from '../bm-bank-transaction-family-base.component';


@Component({
    selector: 'bm-bank-transaction-family-full',
    templateUrl: 'bm-bank-transaction-family-full.component.html',
    standalone: false
})
export class BmBankTransactionFamilyFullComponent extends BmBankTransactionFamilyBaseComponent implements OnInit {

    ngOnInit() {
        super.ngOnInit();
    }

}
